import { LinkImage }from '../../components';
import LaTerceraLogo from '../../assets/logos/tercera.png';
import CNNLogo from '../../assets/logos/cnn.png';
import Tele13Logo from '../../assets/logos/tele13.png';
import TVNLogo from '../../assets/logos/tvn.png';
import LaClaveLogo from '../../assets/logos/laclave.png';
import halfCircle from '../../assets/float-3.svg';
import harvardLogo from '../../assets/logos/eng/logo-hbs.png';
import missLogo from '../../assets/logos/eng/logo-miss-lizz.png'
import robLogo from '../../assets/logos/eng/logo-rob-mapoli.png'
import supPill from '../../assets/logos/eng/logo-startuppill.png'
import styles from './media.module.scss';
import { useTranslation } from 'react-i18next';
import i18n from '../../configs/i18n';

const Media = () => {
	
	const [t ] = useTranslation()
	const userLang = i18n.language;

	return (
		<section id="media" className={styles.container}>
			<div className={styles.content_wrapper}>
				<h2>
					<b>{t('section.testimonials.title2')}</b>
				</h2>
				{ userLang === 'es' ? (
					<iframe className={styles.videoEmbed} width="560" height="315" src="https://www.youtube.com/embed/tvuOauOarZE" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" ></iframe>
				):(
					<></>
				)}
			<div className={styles.card_container}>
				{ userLang === 'en' ? 
				(
					<>
						<img alt='half circle decoration' src={halfCircle} className={styles.halfCircle}/>
							<LinkImage
								href="https://www.hbs.edu/mba/blog/post/harvard-team-wins-second-place-in-miint-impact-investing-competition"
								srcImage={harvardLogo}
							/>
							<LinkImage
								href="https://www.misslizsteaparties.com/podcast/episode/29bc5a1f/teatime-with-miss-liz-t-e-a-open-discussion-alvaro-carrasco-braveup"
								srcImage={missLogo}
							/>
							<LinkImage
								href="https://www.robnapoli.com/podcast/episode/2a5e4be9/stopping-bullying-globally-with-brave-up-ceo-alvaro-carrasco"
								srcImage={robLogo}
							/>
							<LinkImage
								href="https://startupill.com/62-best-new-york-social-impact-startups-the-future-of-events/"
								srcImage={supPill}
							/>
						
						</>
					) 
					: 
					(
						<>
						<img alt='half circle decoration' src={halfCircle} className={styles.halfCircle}/>
							<LinkImage
								href="https://www.latercera.com/tendencias/noticia/lado-oscuro-ciberacoso-sexting/679001/"
								srcImage={LaTerceraLogo}
							/>
							<LinkImage
								href="https://www.cnnchile.com/pais/chilenos-crean-app-que-busca-disminuir-el-bullying-escolar_20170726/"
								srcImage={CNNLogo}
							/>
							<LinkImage
								href="https://www.youtube.com/watch?v=c9v5rdLsX44&t=12s"
								srcImage={Tele13Logo}
							/>
							<LinkImage
								href="https://www.youtube.com/watch?v=XehqlmfvrDU&ab_channel=BRAVEUP%21"
								srcImage={TVNLogo}
							/>
							<LinkImage
								href="https://www.youtube.com/watch?v=jGlGjvrAwW0&ab_channel=RadioLaClave"
								srcImage={LaClaveLogo}
							/>
						
						</>
					)}	
				</div>
			</div>
		</section>
	);
};
export default Media;
